
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { ginzaPizzaPizzatopImage } from "@src/constants/images";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import { murakamiMasanori } from "@src/constants/authors";
export const meta = {
  path: "/media/ginza/pizza",
  title: "【やっぱりこの2つ】銀座で絶対外さないピザランチはここ！",
  description: "銀座のピザランチといっても店舗がたくさんあってどれが1番かわからない。そんな方にオススメしたいのが紹介する２店舗。絶対に外さない不動のNo.1のピザの名店と、どんなシチュエーションにも対応してくれるお店の2店をご紹介します。どちらも釜で焼く本格的なピザで、コスパ抜群のお店なのでチェックしてみてください。",
  topImg: ginzaPizzaPizzatopImage,
  author: murakamiMasanori,
  tags: ["銀座", "ピザ", "行列店", "人気店", "お店の紹介", "デート", "おしゃれな内装", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`銀座のピザで抑えておけば間違いのない 2 店舗をご紹介します。`}</p>
    <p>{`不動の No.1 で行列が絶えないお店ヴォメロ、どんなシチュエーションにも対応できる近代的な外観が特徴的なイゾラ ブル。`}</p>
    <p>{`どちらも釜で焼く本格的なナポリピザを味わうことができ、ランチだとコスパも抜群。行列情報も併せて記載しているので、ぜひチェックしてみてください。`}</p>
    <h2>{`【東銀座】ヴォメロ`}</h2>
    <InstaImage postId="CC7FQKhngC2" mdxType="InstaImage" />
    <h3>{`銀座 No.１のピザ`}</h3>
    <p>{`東銀座の飲食店が並ぶエリアに、クリーム色の一軒家がヴォメロの目印。`}</p>
    <p>{`食べログの評価は３.7 を超え、百名店に毎年選出されているピザの名店は、銀座で不動の地位を築いている。
ランチ、ディナー共にいろんな方が訪れ、行列ができることもしばしばで、銀座でピザを食べるしには絶対外せないお店の一つです。`}</p>
    <p>{`そんなヴォメロの特徴とピザについてご紹介します。`}</p>
    <h3>{`イタリア語が飛び交う店内`}</h3>
    <p>{`店内に入ってメニューを見たり、店内を見渡していると、イタリア語が聞こえてきます。
ヴォメロでは店員さん同士がメニューのやり取りや注文をイタリア語で話しており、現地に近い雰囲気を演出しているのも、一緒に行く人と楽しめるポイントです。`}</p>
    <h3>{`日本屈指のピザ職人`}</h3>
    <p>{`「真のナポリピッツア協会」認定店出身で、18 歳から窯焼きを始めて 20 年という吉武紀英さんがピザを監修しています。`}</p>
    <p>{`ピザ生地は現地の生地を使い、直径約 30 センチの「インパクトのあるボリューム感」と、サックリと歯切れがいい「アゴの疲れない硬さ」をテーマとしてピザを作るそうです。`}</p>
    <p>{`筆者が実際に行った際も、びっくりするくらいのボリューム感と、サクサクと食べれてしまう食感が印象に残っています。`}</p>
    <h3>{`コスパ抜群のランチ`}</h3>
    <InstaImage postId="B8LlqDUBGAd" mdxType="InstaImage" />
    <InstaImage postId="B5O2ic_gZYl" mdxType="InstaImage" />
    <p>{`ランチは平日、休日問わずに行列が絶えないのですが、その理由の一つにコスパの良さがあります。`}</p>
    <p>{`前菜、メインのピザ、食後のドリンクを併せて 1,320 円の値段は、銀座という立地やご飯のボリュームを考えても文句なしの値段設定。`}</p>
    <p>{`銀座で 1 番人気のピザの味をお手頃の値段で食べられるのが、ヴォメロの魅力です。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`銀座で絶対に外せない店だからこそ、人気で行列ができることが多いヴォメロ。`}</p>
    <p>{`平均的な行列人数は 10〜20 人で、待ち時間は 15〜30 分。
実際に私がお店に行った時は、平日の 14 時で 10 人待ち、15 分ほどで入店ができました。`}</p>
    <p>{`早めの時間帯は狙い目ですが、並んでも待ち時間は少ないので、そこまで行列は気にしなくても大丈夫です。`}</p>
    <hr></hr>
    <h2>{`【銀座一丁目】イゾラ ブル`}</h2>
    <InstaImage postId="Be222jyh3fi" mdxType="InstaImage" />
    <h3>{`近代的な一軒家レストラン`}</h3>
    <InstaImage postId="B3BWwy7g0p9" mdxType="InstaImage" />
    <p>{`4 階建ての近代的な一軒家のイタリアンレストランが特徴的なお店がイゾラ ブル。
テラス風の窓際席や半個室、ロフト席も完備していて、いろんなシチュエーションにマッチするお店。
夜はブルーネオンに輝き、より一層シックなイメージを掻き立ててくれます。`}</p>
    <p>{`友達とのランチ、恋人とのディナーなど、銀座でピザを食べたい時には抑えておきたいお店です。`}</p>
    <h3>{`オリジナルのピザ釜`}</h3>
    <InstaImage postId="B4Ja5X8Awyh" mdxType="InstaImage" />
    <p>{`イゾラ ブルのピザ釜は、本場南イタリアの窯職人に製作していただいたもので、青色に輝くピザ釜は一度見たら忘れない特徴的な外観。
ピザ釜の中央には、「 ISOLA」とお店の名前も刻まれています。`}</p>
    <p>{`また、薪を焼いて作る薪釜は、独特の香ばしい香りをピザに浸透させ、食べた瞬間にその香ばしさが口の中に広がるピザになっています。
本格的なナポリピザを銀座で味わえる名店です。`}</p>
    <h3>{`コスパ抜群のランチ`}</h3>
    <InstaImage postId="Bm-tMjFlris" mdxType="InstaImage" />
    <InstaImage postId="BmplzgjlJUl" mdxType="InstaImage" />
    <p>{`ピザランチの値段はトッピングなどをしない場合、1,200 円で食べることができます。
ボリューム感のあるサラダと、本日のピザを選ぶことができ、いろんな種類のピザから選ぶことができます。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`銀座でいろんなシーンに使えるからこそ、行列ができることが多いのではないかと思いますが、イゾラ ブルでは行列ができることが少ないです。
4 階建てで、席数が 100 席あることが行列ができにくくなっている理由です。
ぜひ、安心してランチもお越しください。`}</p>
    <ShopInfoBox shopId="bsgo08223akg00flic80" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;